import { render, staticRenderFns } from "./InsurerListSideMenu.vue?vue&type=template&id=1ba124cb&scoped=true"
import script from "./InsurerListSideMenu.vue?vue&type=script&lang=js"
export * from "./InsurerListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba124cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba124cb')) {
      api.createRecord('1ba124cb', component.options)
    } else {
      api.reload('1ba124cb', component.options)
    }
    module.hot.accept("./InsurerListSideMenu.vue?vue&type=template&id=1ba124cb&scoped=true", function () {
      api.rerender('1ba124cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerListSideMenu.vue"
export default component.exports